import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_CATEGORIES_API_PATHS } from '../constants/categories-api-paths.constants';

type CategoryPosition = {
  id: string;
  position: number;
};

type UseUpdateCategoriesPositionsResult = {
  updatePositions: (categories: CategoryPosition[]) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useUpdateCategoriesPositions(): UseUpdateCategoriesPositionsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updatePositions = async (categories: CategoryPosition[]): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.patch(ADMIN_CATEGORIES_API_PATHS.UPDATE_POSITIONS, { categories });

      enqueueSnackbar('Les positions ont été mises à jour', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour des positions'),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updatePositions, isSubmitting };
}
